import React, { useEffect } from "react";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import { Link } from "react-router-dom";
import PackageCard from "../components/card/PackageCard";
import { ImgUrl, packageImgUrl } from "../../constant";
import { referencePackageImgUrl } from "../../admin/Constant";
import { useCombinedpackageQuery } from "../../redux/API/PackageApi";

const RelatedPackages = () => {
  const { data: combinedData, isLoading, error } = useCombinedpackageQuery();
  console.log(combinedData, "combinedDataaa");

  useEffect(() => {}, []);

  return (
    <div>
      <Navbar />

      <h1>Combined Packages</h1>

      <section className="container mt-5">
        <h4>Combined Packages</h4>
        <div className="row gy-3">
          {isLoading ? (
            <p className="text-center">Loading...</p>
          ) : error ? (
            <p className="text-center">Error fetching data!</p>
          ) : combinedData && combinedData?.data?.length > 0 ? (
            
              <div>
                <div className="row gy-3">
                  {combinedData?.data?.map((packageItem) => (
                    <div key={packageItem?._id} className="col-lg-4">
                      <Link
                        to={`/relatedpackage/${packageItem?.slug}`}
                        className="text-decoration-none text-unset"
                      >
                        <PackageCard
                          title={packageItem?.name}
                          location={packageItem?.location}
                          price={packageItem?.price}
                          img={`${ImgUrl}${packageImgUrl}${packageItem?.images[0]}`}
                          itinerary={packageItem?.itinerary}
                          otherInfo={packageItem?.otherInfo}
                          overview={packageItem?.overview}
                          alt="Package Image"
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
          
          ) : (
            <p className="text-center">No Combined Packages Available</p>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RelatedPackages;
